import './_components.js';

document.addEventListener('DOMContentLoaded', function () {
	document.querySelectorAll(".question__accordeon_item_title").forEach(function (title) {
		title.addEventListener("click", function () {
			const currentItem = this.parentElement;
			const content = currentItem.querySelector(".question__accordeon_item_content");

			// Закрываем все открытые элементы
			document.querySelectorAll(".question__accordeon_item").forEach(function (item) {
				const itemContent = item.querySelector(".question__accordeon_item_content");
				if (item !== currentItem) {
					itemContent.style.display = "none";
					item.querySelector(".question__accordeon_item_title").classList.remove("active");
				}
			});

			// Переключаем состояние текущего элемента
			if (content.style.display === "flex") {
				content.style.display = "none";
				this.classList.remove("active");
			} else {
				content.style.display = "flex";
				this.classList.add("active");
			}
		});
	});
});

document.addEventListener("DOMContentLoaded", function () {
	const infoItems = document.querySelectorAll('.case__info');
	const caseItems = document.querySelectorAll('.case__item');

	infoItems.forEach(info => {
		info.addEventListener('click', function () {
			const id = this.getAttribute('data-id');

			// Удаляем active у всех case__info и case__item
			infoItems.forEach(el => el.classList.remove('active'));
			caseItems.forEach(el => el.classList.remove('active'));

			// Добавляем active текущему info и соответствующему case__item
			this.classList.add('active');
			caseItems.forEach(el => {
				if (el.getAttribute('data-id') === id) {
					el.classList.add('active');
				}
			});
		});
	});
});

document.addEventListener("DOMContentLoaded", () => {
	const calcItems = document.querySelectorAll(".calc__item");
	const calcInfos = document.querySelectorAll(".calc__info");

	calcItems.forEach((item, index) => {
		const prevBtn = item.querySelector(".calc__item_prev");
		const nextBtn = item.querySelector(".calc__item_next");

		const activateItem = (newIndex) => {
			calcItems.forEach(i => i.classList.remove("active"));
			calcInfos.forEach(i => i.classList.remove("active"));
			calcItems[newIndex].classList.add("active");
			calcInfos[newIndex].classList.add("active");
		};

		if (prevBtn) {
			prevBtn.addEventListener("click", (e) => {
				e.preventDefault();
				const newIndex = (index - 1 + calcItems.length) % calcItems.length;
				activateItem(newIndex);
			});
		}

		if (nextBtn) {
			nextBtn.addEventListener("click", (e) => {
				e.preventDefault();
				const newIndex = (index + 1) % calcItems.length;
				activateItem(newIndex);
			});
		}
	});
});

document.addEventListener("DOMContentLoaded", function () {
	const rightItems = document.querySelectorAll(".how__right_item");
	const leftTexts = document.querySelectorAll(".how__left_text");

	rightItems.forEach(item => {
		item.addEventListener("click", () => {
			const id = item.getAttribute("data-id");

			// Удаляем active у всех текстов
			leftTexts.forEach(text => text.classList.remove("active"));

			// Добавляем active к нужному тексту
			const targetText = document.querySelector(`.how__left_text[data-id="${id}"]`);
			if (targetText) {
				targetText.classList.add("active");
			}
		});
	});
});
